(() => {
  if (window.atpVideoActionReady) return;
  window.atpVideoActionReady = true;
  document.addEventListener('click', event => {
    const action = event.target.closest('[data-atp-watch-video]');
    if (!action) return;
    const id = action.dataset.atpWatchVideo;
    const gallery = document.getElementById('slider-product-main-media');
    const thumbnails = document.getElementById('slider-product-thumbnails-media');
    const slide = gallery && Array.from(gallery.children).find(item => item.dataset.atpMediaId === id);
    const thumbnail = thumbnails && Array.from(thumbnails.children).find(item => item.dataset.atpMediaId === id);
    const player = slide && slide.querySelector('video');
    if (!player || !thumbnail || !thumbnail.hasAttribute('data-nav')) return;
    event.preventDefault();
    thumbnail.click();
    player.focus({ preventScroll: true });
    gallery.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const play = player.play();
    if (play) play.catch(() => {});
  });
})();
